/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { CustomerApiService } from './customer-api.service';
import { ConfigService } from 'src/app/service/config.service';

const CUSTOMER_ENDPOINTS = {
  list: '/v3/newsletter/subscriptions',
  update: '/v2/newsletter/update',
  remove: '/v2/newsletter/remove',
  dismissNews: '/v3/news_dismissal/dismiss',
} as const;

const NEWSLETTER_ENDPOINTS = {
  generate: '/generate_one',
  preview: '/api/create_layout',
  scores: '/available_scores',
} as const;

@Injectable({
  providedIn: 'root',
})
export class NewsletterApiService {
  private newsletterUrl: string;

  constructor(
    private api: CustomerApiService,
    private http: HttpClient,
    private config: ConfigService,
  ) {
    this.newsletterUrl = this.config.appConfig.urlNewsletterApi;
  }

  // CUSTOMER API ----------------------------------------------------------

  allNewsletter(): Observable<any> {
    return this.api.get<any>(CUSTOMER_ENDPOINTS.list).pipe(
      shareReplay(),
      map((res) => JSON.parse(JSON.stringify(res))['hits']),
    );
  }

  editNewsletter(data: any): Observable<any> {
    return this.api.post(CUSTOMER_ENDPOINTS.update, data);
  }

  removeNewsletter(uid: string): Observable<any> {
    return this.api.get(CUSTOMER_ENDPOINTS.remove, { uid });
  }

  dismissNews(
    idsArray: string[],
    newsletterId: string | null,
    resourceType: string,
  ): Observable<string> {
    const body: Record<string, any> = {
      ids: idsArray,
      resource_type: resourceType,
    };
    if (newsletterId) {
      body.context = 'ylrn:artifact:newsletter:' + newsletterId;
    }
    return this.api.postText(CUSTOMER_ENDPOINTS.dismissNews, body);
  }

  // NEWSLETTER API (different base URL — token injected by AuthInterceptor) -

  generateNewsletter(data: any): Observable<any> {
    return this.http.post(
      this.newsletterUrl + NEWSLETTER_ENDPOINTS.generate,
      data,
    );
  }

  previewNewsletter(
    id: string,
    from: number,
    to: number = from + 1,
  ): Observable<any> {
    return this.http.post(this.newsletterUrl + NEWSLETTER_ENDPOINTS.preview, {
      uid: id,
      from,
      to,
    });
  }

  getNewsletterScores(): Observable<any> {
    return this.http.get(this.newsletterUrl + NEWSLETTER_ENDPOINTS.scores);
  }
}
